import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  GeographicZone,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/geographicZones`;

export async function getGeographicZonesQuery({
  sellerId,
}: {
  sellerId: string;
}): Promise<BackResponse<GeographicZone[]> | BackResponseFailure> {
  try {
    const response = await apiCall<BackResponse<GeographicZone[]>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
